/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRotate, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import ComponentsLibraryIcon from "../../../assets/icons/componenets.svg2";
import HelpButton from "../../HelpContent/HelpButton";
import { useGetComponentsStatsQuery, useGetProcessStatsQuery } from "../../store/slices/settingsSlice";
import { AbsoluteLoadingIndicator } from "../FullScreenLoadingIndicator";

export default function ComponentsWidget() {
  const [period, setPeriod] = useState("");
  const [activeProcessCount, setActiveProcessCount] = useState(0);
  const [processCount, setProcessCount] = useState(0);

  const getDateParam = () => {
    if (period === "today") return "today";
    if (period === "week") return "week";
    if (period === "month") return "month";
    return "";
  };

  // Fetch components/projects data
  const {
    data: componentsData,
    isLoading: componentsLoading,
    isFetching: componentsFetching,
    refetch: refetchComponents,
  } =
    useGetComponentsStatsQuery({});

  // Fetch process stats - active
  const {
    data: activeProcessData,
    isLoading: activeProcessLoading,
    isFetching: activeProcessFetching,
    refetch: refetchActiveProcess,
  } =
    useGetProcessStatsQuery({ started: getDateParam(), ...(getDateParam() && { status: "active" }) });

  // Fetch process stats - all
  const {
    data: allProcessData,
    isLoading: allProcessLoading,
    isFetching: allProcessFetching,
    refetch: refetchAllProcess,
  } =
    useGetProcessStatsQuery({ started: getDateParam() });

  const handleRefresh = () => {
    refetchComponents();
    refetchActiveProcess();
    refetchAllProcess();
  };

  useEffect(() => {
    if (activeProcessData) {
      const count = activeProcessData.reduce((sum, stat) => sum + (stat.Dispatched || 0), 0);
      setActiveProcessCount(count);
    }
  }, [activeProcessData]);

  useEffect(() => {
    if (allProcessData) {
      const count = allProcessData.reduce((sum, stat) => sum + (stat.Dispatched || 0), 0);
      setProcessCount(count);
    }
  }, [allProcessData]);

  const loading =
    componentsLoading ||
    activeProcessLoading ||
    allProcessLoading ||
    componentsFetching ||
    activeProcessFetching ||
    allProcessFetching;

  return (
    <div className="position-relative px-2 d-flex flex-column h-100">
      <AbsoluteLoadingIndicator loading={loading} />
      <div className="d-flex p-3 pb-1 align-items-center ">
        <ComponentsLibraryIcon width={20} className="white opacity-50" />
        <Link className="btn p-0 text-white" to="/library/components">
          <h6 className="m-0 mx-2 small fw-bold">SOLUTIONS</h6>
        </Link>
        <button
          className="btn p-0 text-white ms-2"
          onClick={handleRefresh}
          disabled={loading}
          title="Refresh components data"
        >
          <FontAwesomeIcon icon={faRotate} className={`opacity-50 ${loading ? 'spin' : ''}`} />
        </button>
        <HelpButton helpKey="widget-solutions" iconClassName="white" />{" "}
        <FontAwesomeIcon
          icon={faGripVertical}
          className="ms-4 opacity-50 widget-header"
        />
      </div>
      <div className="">
        {[
          {
            label: (
              <div className="opacity-50">
                <Link className="btn p-0 text-white" to="/library/components">
                  Components
                </Link>
              </div>
            ),
            value: `${componentsData?.total || 0}`,
          },

          {
            label: <div className="opacity-50">Active components</div>,
            value: `${componentsData?.total || 0}`,
          },
          {
            label: (
              <div className="opacity-50">
                <Link className="btn p-0 text-white" to="/reporting/processes">
                  Running processes
                </Link>
              </div>
            ),
            value: <div>{activeProcessCount}</div>,
          },
          {
            label: (
              <div className="opacity-50">
                <Link className="btn p-0 text-white" to="/reporting/processes">
                  All processes
                </Link>
              </div>
            ),
            value: <div>{processCount}</div>,
          },
        ].map((r, i) => (
          <React.Fragment key={i}>
            <hr className="m-1" />
            <div className="d-flex justify-content-between px-3">
              <span className="fw-bold p-1">{r.label}</span>
              <h3 className="fw-bold m-0 p-1">{r.value}</h3>
            </div>
          </React.Fragment>
        ))}
      </div>
      <div className="flex-grow-1" />

      <div className="px-3">
        <hr />
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("")}
        >
          ALL
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "today" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("today")}
        >
          DAY
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "week" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("week")}
        >
          WEEK
        </button>
        <button
          type="button"
          className={`btn btn-light btn-sm px-2 py-0 rounded-pill text-purple fw-bold mx-1 ${
            period === "month" ? "" : "opacity-50"
          }`}
          onClick={() => setPeriod("month")}
        >
          MONTH
        </button>
      </div>
    </div>
  );
}
